const Constants = {
  REMOVE_ACTIVITIES: 'ActivityLog.REMOVE_ACTIVITIES',
  LOAD_ACTIVITIES: 'ActivityLog.LOAD_ACTIVITIES',
  LOAD_ACTIVITIES_XLS: 'ActivityLog.LOAD_ACTIVITIES_XLS',
  SET_ACTIVITIES: 'ActivityLog.SET_ACTIVITIES',
  SET_ACTIVITIES_XLS: 'ActivityLog.SET_ACTIVITIES_XLS',
  SET_MESSAGE: 'ActivityLog.SET_MESSAGE',
  SET_ERROR: 'ActivityLog.SET_ERROR',
  SET_LOADING: 'ActivityLog.SET_LOADING',
  UPDATE_ACTIVITYTYPES: 'ActivityLog.UPDATE_ACTIVITYTYPES',
  LOAD_ACTIVITYTYPES: 'ActivityLog.LOAD_ACTIVITYTYPES',
  SET_ACTIVITYTYPES: 'ActivityLog.SET_ACTIVITYTYPES',
  LOAD_USERS: 'ActivityLog.LOAD_USERS',
  SET_USERS: 'ActivityLog.SET_USERS',
  UPDATE_ACTIVITIES_API: '/api/v1/activity/update_status_activity_type',
  LOAD_ACTIVITIES_API: '/api/v1/activity/get_list_activities_by',
  LOAD_ACTIVITYTYPES_API: '/api/v1/activity/get_list_activity_types_by',
  LOAD_USERS_API: '/api/v1/users/get_list_by_quanly',
  REMOVE_ACTIVITIES_API: '/api/v1/activity/remove_activities',
  LOAD_ACTIVITIES_EXCEL_API: '/api/v1/activity/export_list_activities_by',
}

export default  Constants


// WEBPACK FOOTER //
// ./src/views/Admin/ActivityLog/constants.js